// Page to create a logbook entry (CompletedTask) from a task.
// User can elect to modify the task on creating the entry.

import { useParams, useNavigate } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import { useStatusMessage } from '../../components';
// TODO: Get rid of useSharedItemPageState
import { useSharedItemPageState, pageLogbookEntryFromTask } from '../item/useSharedItemPageState';
import { LogbookEditEntry } from './LogbookEditEntry';
import { LogbookUpdateTask  /*, 
          UpdateTaskFromDue, 
          UpdateTaskFromNow,
          UpdateTaskNothing, 
          UpdateTaskDelete */} from './LogbookUpdateTask';
import { updateCompletedTask } from '../../utilities/Database';
import { urlForLogbookForId } from '../../fleet-shared/Urls.mjs';

export const LogbookEntryFromTask = () => {
  // Passed in URL
  const { itemId, logbookId } = useParams();
  const { taskId } = useParams();

  // For showing loading status.
  const [StatusMessage, {showLoading, showError, hideStatus}] = useStatusMessage();

  // Page data/state
  const [{ item, logbook, Breadcrumbs, completedTask, task }] = useSharedItemPageState({
      page: pageLogbookEntryFromTask, 
      itemId: itemId,
      logbookId: logbookId,
      pageItemId: taskId,
      showLoading: showLoading, 
      hideLoading: hideStatus, 
      showError: showError
  });

  const navigate = useNavigate();

  // Saves edited logbook entry. Runs per autosave flush -- must NOT
  // navigate; the Done button below is what leaves the page. Throws with
  // errors (the empty-name case is normally held by the form's validate
  // before it gets here).
  async function handleSaveLogbookEntry(entry) {
    if (!entry.name || entry.name.length === 0) {
      throw new Error('Please enter a name.');
    }
    // Set id's
    entry.id = completedTask.id;
    entry.itemId = itemId;
    entry.taskId = taskId;

    // TODO: What if they want to change?
    entry.itemCounterId = completedTask.itemCounterId;

    await updateCompletedTask(entry);
  }

  function handleDelete() {
    // If there are attachments and this was the create, delete them...
  }

  // The user deleted the underlying task from `LogbookUpdateTask`. Drop
  // the dangling `taskId` reference on the logbook entry so the page
  // doesn't try to re-load a now-missing task on the next render.
  function handleTaskDeleted() {
    if (completedTask) {
      completedTask.taskId = null;
    }
  }

  if ((null === item) || (null === completedTask) || (null === task)) {
    return (
      <StatusMessage />
    );
  }

  return (
      <div className='text-center'>
          <Breadcrumbs />
          <StatusMessage />
          <LogbookUpdateTask
            task={task}
            item={item}
            onTaskDeleted={handleTaskDeleted}
          />
          <LogbookEditEntry
            entry={completedTask}
            item={item}
            logbook={logbook}
            handleSave={handleSaveLogbookEntry}
            handleDelete={handleDelete}
          />

          {/* Edits autosave as they're made; Done just leaves the page.
              Navigating unmounts the form, which flushes any pending edit
              through the save queue. */}
          <div className='container m-2'>
            <Button
              className='col-3'
              onClick={() => navigate(urlForLogbookForId(itemId, logbookId), { replace: true })}
            >
              Done
            </Button>
          </div>
      </div>
  );
}

export default LogbookEntryFromTask;
